import { z } from "zod";
import { IdSchema, IsoTimestampSchema, NonEmptyStringSchema, NonNegativeIntegerSchema, PositiveIntegerSchema, requireSourceOrRuleRef, RuleTraceRefSchema, SourceRefSchema, StorageRefSchema, UnknownRecordSchema } from "./source.js";
const OutputProvenanceFields = {
    sourceRefs: z.array(SourceRefSchema),
    ruleTraceRefs: z.array(RuleTraceRefSchema)
};
export const DeviceInstanceSchema = requireSourceOrRuleRef(z
    .object({
    ...OutputProvenanceFields,
    id: IdSchema,
    specItemRef: IdSchema,
    productPartNo: NonEmptyStringSchema,
    label: NonEmptyStringSchema,
    quantity: PositiveIntegerSchema,
    apartmentTypeId: IdSchema.optional(),
    metadata: UnknownRecordSchema
})
    .strict());
export const MappingEdgeSchema = requireSourceOrRuleRef(z
    .object({
    ...OutputProvenanceFields,
    id: IdSchema,
    fromRef: IdSchema,
    toRef: IdSchema,
    edgeKind: z.enum([
        "controls",
        "terminates_at",
        "communicates_with",
        "powers",
        "maps_to_point",
        "satisfies_requirement"
    ]),
    label: NonEmptyStringSchema,
    riskRefs: z.array(IdSchema)
})
    .strict());
export const MappingScheduleRowSchema = requireSourceOrRuleRef(z
    .object({
    ...OutputProvenanceFields,
    id: IdSchema,
    apartmentTypeId: IdSchema.optional(),
    deviceInstanceId: IdSchema,
    logicalControllerRef: IdSchema.optional(),
    physicalTerminationRef: IdSchema.optional(),
    room: NonEmptyStringSchema.optional(),
    cableImplication: NonEmptyStringSchema.optional(),
    commissioningNote: NonEmptyStringSchema,
    riskRefs: z.array(IdSchema)
})
    .strict());
export const CommissioningTaskSchema = requireSourceOrRuleRef(z
    .object({
    ...OutputProvenanceFields,
    id: IdSchema,
    projectId: IdSchema,
    title: NonEmptyStringSchema,
    description: NonEmptyStringSchema,
    deviceInstanceIds: z.array(IdSchema),
    status: z.enum(["planned", "ready", "blocked", "done"]),
    riskRefs: z.array(IdSchema)
})
    .strict());
export const RequirementSatisfactionClaimSchema = requireSourceOrRuleRef(z
    .object({
    ...OutputProvenanceFields,
    id: IdSchema,
    requirementId: IdSchema,
    satisfiedByRefs: z.array(IdSchema),
    status: z.enum([
        "satisfied",
        "satisfied_with_assumption",
        "not_satisfied",
        "not_applicable"
    ]),
    explanation: NonEmptyStringSchema,
    riskRefs: z.array(IdSchema)
})
    .strict());
export const ComplianceRowSchema = requireSourceOrRuleRef(z
    .object({
    ...OutputProvenanceFields,
    id: IdSchema,
    requirementId: IdSchema,
    complianceStatus: z.enum([
        "compliant",
        "compliant_with_assumption",
        "non_compliant",
        "rfi_required",
        "excluded"
    ]),
    plainEnglish: NonEmptyStringSchema,
    riskRefs: z.array(IdSchema)
})
    .strict());
export const RequirementTraceabilityRowSchema = requireSourceOrRuleRef(z
    .object({
    ...OutputProvenanceFields,
    id: IdSchema,
    requirementId: IdSchema,
    sourceRequirementText: NonEmptyStringSchema,
    outputRefs: z.array(IdSchema),
    claimIds: z.array(IdSchema),
    riskRefs: z.array(IdSchema)
})
    .strict());
export const ExportArtifactSchema = z
    .object({
    id: IdSchema,
    exportBundleId: IdSchema,
    kind: z.enum([
        "specification",
        "bom",
        "risk_register",
        "rfi_register",
        "mapping_schedule",
        "compliance_matrix",
        "traceability_matrix",
        "ve_summary"
    ]),
    format: z.enum(["json", "xlsx", "pdf", "csv", "md", "html"]),
    storageRef: StorageRefSchema,
    hash: NonEmptyStringSchema,
    createdAt: IsoTimestampSchema
})
    .strict();
export const ExportBundleSchema = z
    .object({
    id: IdSchema,
    orgId: IdSchema,
    projectId: IdSchema,
    specSnapshotId: IdSchema,
    outputGraphId: IdSchema,
    status: z.enum(["draft", "ready", "blocked", "superseded"]),
    artifacts: z.array(ExportArtifactSchema),
    riskRefs: z.array(IdSchema),
    createdAt: IsoTimestampSchema
})
    .strict();
export const OutputGraphSchema = requireSourceOrRuleRef(z
    .object({
    ...OutputProvenanceFields,
    id: IdSchema,
    orgId: IdSchema,
    projectId: IdSchema,
    version: NonEmptyStringSchema,
    specSnapshotId: IdSchema,
    status: z.enum(["draft", "ready", "blocked", "superseded"]),
    deviceInstances: z.array(DeviceInstanceSchema),
    mappingEdges: z.array(MappingEdgeSchema),
    mappingScheduleRows: z.array(MappingScheduleRowSchema),
    commissioningTasks: z.array(CommissioningTaskSchema),
    requirementSatisfactionClaims: z.array(RequirementSatisfactionClaimSchema),
    complianceRows: z.array(ComplianceRowSchema),
    requirementTraceabilityRows: z.array(RequirementTraceabilityRowSchema),
    exportBundleIds: z.array(IdSchema),
    productQuantityTotals: z.record(NonEmptyStringSchema, NonNegativeIntegerSchema),
    createdAt: IsoTimestampSchema
})
    .strict());
//# sourceMappingURL=output.js.map